import GenerateHelpModal from './GenerateHelpModal'

export default GenerateHelpModal
